export interface ICalendar {
  date: Date
  disabled: boolean
  selected: boolean
}
